import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import MainContent from 'components/MainContent';
import SimpleHeader from 'components/SimpleHeader';
import store from 'stores/RootStore';

import NavHeader from '../../UI/NavHeader/NavHeader';
import NavSidebar from '../../UI/NavSidebar/NavSidebar';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100vh;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;

  p {
    margin-top: 10px;
  }
`;

function DesktopLayout() {
  return store.user.authenticated ? (
    <>
      <NavSidebar />
      <Container>
        <NavHeader />
        <MainContent />
      </Container>
    </>
  ) : (
    <>
      <Container>
        <SimpleHeader />
        <MainContent />
      </Container>
    </>
  );
}

export default observer(DesktopLayout);
